import { useAppLocation, getDomain, StoreMetadata } from "../";
import { useEffect, useMemo, useState } from "react";

export const isInRootRoute = (
  pathname: string,
  ownerId: string,
  partnerId: string,
): boolean => {
  const catalogOwnerPath = `/catalogo/${ownerId}/`;
  const catalogPartnerPath = `/catalogo/${partnerId}/`;
  const catalogOwnerPathWithoutSlash = `/catalogo/${ownerId}`;
  const catalogPartnerPathWithoutSlash = `/catalogo/${partnerId}`;

  return (
    pathname === "/" ||
    pathname === "customize" ||
    pathname?.includes("/customize/") ||
    [
      catalogOwnerPath,
      catalogPartnerPath,
      catalogOwnerPathWithoutSlash,
      catalogPartnerPathWithoutSlash,
    ].some((path) => {
      const subPaths = path.split("/").filter(Boolean);
      return pathname === path && subPaths.length === 2;
    })
  );
};

export const useCatalogue = ({
  storeMetadata,
}: {
  storeMetadata: StoreMetadata;
}) => {
  const { pathname } = useAppLocation();
  const partnerId = storeMetadata?.userNetwork?.urlSummer;
  const isPrime = storeMetadata?.prime?.id !== undefined;
  const ownerId = storeMetadata?.ownerId;
  const [isInCatalogueRoot, setIsInCatalogueRoot] = useState<boolean>(
    isInRootRoute(pathname, ownerId, partnerId),
  );
  const storeUserPathName = storeMetadata?.userNetwork.urlSummer || ownerId;

  useEffect(() => {
    setIsInCatalogueRoot(isInRootRoute(pathname, ownerId, partnerId));
  }, [pathname]);

  const isInCategoryView = useMemo((): boolean => {
    return pathname.indexOf("/categoria/") >= 0;
  }, [pathname]);

  const urlCatalogue = () => {
    const urlNormal = `${getDomain()}/catalogo/${ownerId}`;
    const urlPrime = `https://${partnerId}.domun.co`;
    return isPrime ? urlPrime : urlNormal;
  };

  return {
    urlCatalogue,
    isInCategoryView,
    isInCatalogueRoot,
    storeUserPathName,
    ownerId,
  };
};
